// extracted by mini-css-extract-plugin
module.exports = {"confirmationWrapper":"l","header":"m","title":"n","subHeader":"o","buttonsWrapper":"p","confirmButton":"q","large":"r","cancelButton":"s"};